import { Drawer } from '@tencent/tea-component';
import { ChevronDownIcon } from 'tdesign-icons-react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@store/index';
import { getIfShowAttendee, hideAttendee } from '@store/ui/ui.slice';
import UserMetaInfo from '@component/user-meta-info';
import HostControlZoom from './host-control-zoom';
import { BOOL, XMPPService } from '@tencent/wemeet-websdk-next';
import wemeetClient from '@utils/wemeetClient';

import './Attendee.scss';
import { useAttendee } from '@utils/hooks/useUserList';
import { isUserShareOn, isUserVideoOn, openRecord } from '@utils/helper/media';

export default function Attendee() {
  const visible = useAppSelector(getIfShowAttendee);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onClose = () => {};

  const userList = useAttendee();
  const selfInfo = XMPPService.utils.getSelfUserInfo(userList);
  const selfIsCreator = selfInfo?.is_creator === BOOL.true;
  const selfRoleType = selfInfo?.role_type;
  const selfIsHost = wemeetClient.userCtrl.isHost();
  const selfIsCoHost = wemeetClient.userCtrl.isCoHost();
  const userInfoList = userList.map((user) => {
    const avatarUrl = '';
    const isSelf = wemeetClient.userCtrl.isSelf(user?.id);

    return {
      nickname: user.nickname,
      avatarType: user.avatar_type,
      avatarToken: user.avatar_token,
      userDistrict: user.user_district,
      roleType: user.role_type,
      micOn: user?.up_audio_on?.__value === BOOL.true,
      phoneOn: false,
      videoOn: isUserVideoOn(user),
      shareOn: isUserShareOn(user),
      recordOn: openRecord(user),
      isPhoneUser: false,
      isCreator: user.is_creator === BOOL.true,
      avatarUrl,
      isSelf,
      selfIsCreator,
      selfRoleType,
      id: user.id,
      rtcStream: user.rtcStream,
    };
  });

  return (
    <>
      <Drawer
        visible={visible}
        outerClickClosable={false}
        disableCloseIcon={true}
        onClose={onClose}
        className="attendee"
        style={{ top: '0' }}
      >
        {/* 标题区域 */}
        <div className={'attendee__title'}>
          <ChevronDownIcon
            onClick={() => {
              dispatch(hideAttendee());
            }}
          />
          <span className={'attendee__title__text'}>
            {t('成员({#userCount#})', { userCount: userInfoList.length })}
          </span>
        </div>

        {/* 成员列表 */}
        <ul className={'attendee__list'}>
          {userInfoList.map((userInfo, index) => (
            <UserMetaInfo key={index} {...userInfo} />
          ))}
        </ul>

        {/* 主持人操作区域 */}
        {selfIsHost || selfIsCoHost || selfIsCreator ? (
          <HostControlZoom isHost={selfIsHost} isCoHost={selfIsCoHost} isCreator={selfIsCreator} />
        ) : null}
      </Drawer>
    </>
  );
}
